module.exports = new __parcel__URL__("BrickWorldFilmFestival.7b5e2f0c.avif").toString();